import React from 'react';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../../authConfig';
import { Button } from '@fluentui/react-components';

export const SignInButton = () => {
  const { instance } = useMsal();

  const handleLogin = async () => {
    const result = await instance.loginPopup(loginRequest);
    sessionStorage.setItem('Token', result.idToken);
  };
  return (
    <Button appearance="primary" size="large" onClick={() => handleLogin()}>
      Ingresar
    </Button>
  );
};
